const getCaptionIfOver = (seconds, expected, suffix, fuzzy) => {
	const interval = Math.floor(seconds / expected);
	if (interval !== Infinity && interval > 1) {
		return `${fuzzy ? 'A few' : interval} ${suffix}s ago`;
	} else if (interval === 1) {
		return `One ${suffix} ago`;
	}
	return null;
};

const BREAK_POINTS = [
	{
		min: 31536000,
		suffix: 'year'
	},
	{
		min: 2592000,
		suffix: 'month'
	},
	{
		min: 86400,
		suffix: 'day'
	},
	{
		min: 3600,
		suffix: 'hour'
	},
	{
		min: 60,
		suffix: 'minute',
		fuzzy: true
	},
	{
		min: 1,
		suffix: 'second',
		fuzzy: true
	}
];

const decapme = str => str.charAt(0).toLowerCase() + str.slice(1);

const timeSince = (date, nowDate = new Date(), capitalise = true) => {
	const seconds = Math.floor((nowDate - date) / 1000);
	const result =
		BREAK_POINTS.reduce(
			(accum, point) => accum || getCaptionIfOver(seconds, point.min, point.suffix, point.fuzzy),
			null
		) || 'Just now';

	return capitalise ? result : decapme(result);
};

export default timeSince;



// WEBPACK FOOTER //
// ./src/timeSince.js